"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.StreamPlatform = exports.SessionState = void 0;
var SessionState;
(function (SessionState) {
    SessionState["Waiting"] = "waiting";
    SessionState["Starting"] = "starting";
    SessionState["Countdown"] = "countdown";
    SessionState["Running"] = "running";
    SessionState["Finished"] = "finished";
    SessionState["Cancelled"] = "cancelled";
})(SessionState = exports.SessionState || (exports.SessionState = {}));
var StreamPlatform;
(function (StreamPlatform) {
    StreamPlatform["Dals"] = "dals";
    StreamPlatform["Wowza"] = "wowza";
})(StreamPlatform = exports.StreamPlatform || (exports.StreamPlatform = {}));
//# sourceMappingURL=Session.js.map